import TableItemContextMenu from "./itemContextMenu";

export default TableItemContextMenu;